export const useAdNoticePopup = () => {
  // 광고문자 법률 관련 URL
  const url = 'https://www.law.go.kr/법령/정보통신망이용촉진및정보보호등에관한법률';

  return { url };
};
